import React from "react";
import { Col } from "react-bootstrap";
import "./index.css";
import moment from "moment";
import { useSelector } from "react-redux";
import { PulseLoader } from "react-spinners";

const TaskNotesList = ({ heading, notesList, noteTypes, col,data,loading}) => {
  const profileData = useSelector((state) => state?.dashboard);
  const firstName =  data?.taskMetadata?.firstName || profileData?.profileData?.patientData?.firstName;
  const lastName = data?.taskMetadata?.lastName || profileData?.profileData?.patientData?.lastName;

  const getNoteType = (id) => {
    const temp = noteTypes.filter((item) => item.id === id);
    if(temp.length){
      return temp[0].name;
    }else {
      return '';
    }
  };
  return (
    <Col md={col} className="notes-details-container">
      {heading && <h6 className="heading">{heading}</h6>}
      {loading ?<div className="pulse-loader-container"><PulseLoader                  
                  color={"#70757a"}
                  loading={loading}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                /></div>:!!notesList?.length && (
        <ul className="notes-details-list">
          {notesList.map((item) => {
            return (
                <li className="notes-details-list-item">
                 <div
                  style={{
                    display: "flex",
                    gap: "24px",
                    alignItems: "flex-start",
                  }}
                >
                  {/* LEFT COLUMN */}
                  <div
                    style={{
                      minWidth: "220px",
                      maxWidth: "220px",
                      lineHeight: "1.4",
                    }}
                  >
                    <div style={{ fontWeight: 600,marginBottom: "4px" }}>
                      {item?.createdByPatient
                        ? `${firstName} ${lastName}`
                        : item?.createdByName}
                    </div>

                    <div>
                      {getNoteType(item.noteTypeId)}
                    </div>

                    <div>
                      {moment(item.createdAt).format("MM/DD/YYYY")} –{" "}
                      {moment(item.createdAt).format("hh:mm A")}
                    </div>
                  </div>

                  {/* RIGHT COLUMN */}
                  <div
                    style={{
                      flex: 1,
                      wordBreak: "break-word",
                      lineHeight: "1.5",
                    }}
                  >
                    {item.notes}
                  </div>
                </div>
                </li>
            );
          })}
        </ul>
      )}
    </Col>
  );
};

export default TaskNotesList;
